module.exports = __webpack_public_path__ + "static/media/som_logo.efb0c8e2.png";